import "./solicitudes.scss";
import "../../../../components/atoms/buttons/button.scss";
import { memo } from "react";
import React, { useState, useEffect } from "react";
import "../../../../pages/login/login.scss";
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";
import ConstantesTabla from "../../../../utils/ConstantesTabla";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import ModalMensajes from "../../../../components/molecules/modals/modalMensajes/ModalMensajes";
import { useLocalStorage } from "../../../../hooks/useLocalStorage";
import { formateoFecha } from "../../../../utils/Utils";
import { SpinnerCircle } from "../../../atoms/spinner/Spinner";
import { updateResolucionSolicitud } from "../../../services/ReconocimientoNivelService";

const Solicitudes = ({ solicitudes, handleResolucion, loading }) => {
  const [token] = useLocalStorage("token", "");
  const navigate = useNavigate();
  const marginTop = {
    marginTop: "20px",
  };
  useEffect(() => {}, [token]);
  const [show, setShow] = useState({
    mensaje: false,
  });

  const resolverSolicitud = () => {
    
    updateResolucionSolicitud().then((data)=>{
      
    })
  }

  const handleShow = (e) => {
    setShow(e);
  };
  const handleClose = (e) => {
    setShow(false);
  };

  const accionSol = {
    name: "Acción",
    right: true,
    cell: (row) => (
      <i
        className="fa-solid fa-eye fs-3 mx-2 px-3 cursorPointer faHover"
        onClick={(e) => {
          
          if (row.estado === "EN CURSO" || row.estado === "ANULADA") {
            navigate("/solicitudAnuladaEnCurso", {
              state: { estado: row.estado, id: row.x_wemprecnivcar2021, codigo: row.codigo },
            });
          } 
          if (
            // row.estado === "PRESENTADA" &&
            row.fechaResolucion === null
          ) {
            handleShow({
              mensaje: true,
              content: `Pulse Aceptar si desea mostrar la documentación asociada a la solicitud`,
              contentBold: `${row.codigo}`,
              otherContent: `En dicho caso, se entenderá practicada la notificación a fecha de hoy.`,
              boton: "Aceptar",
              funcion: resolverSolicitud,
              valorFuncion: row.fechaResolucion,
              destinoCerrar:null,
            });
          } 
          if (row.estadoMostrar === "RESOLUCION" && row.fechaResolucion !== null) {
            handleShow({
              mensaje: true,
              titulo: `Resolución notificada el: ${formateoFecha(
                row.fechaResolucion
              )}`,
              // otherContent: `${infoRec.info}`,
              tipo: "tituloBorrador",
              destinoCerrar: null,
            });
          }
        }}
        tabIndex={0}
        title="Ver solicitud"
        aria-label="Ver solicitud"
        role="button"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            if (row.estado === "EN CURSO" || row.estado === "ANULADA") {
              navigate("/solicitudAnuladaEnCurso", {
                state: { estado: row.estado, id: row.x_wemprecnivcar2021, codigo: row.codigo },
              });
            } 
            if (
              // row.estado === "PRESENTADA" &&
              row.fechaResolucion === null
            ) {
              handleShow({
                mensaje: true,
                content: `Pulse Aceptar si desea mostrar la documentación asociada a la solicitud`,
                contentBold: `${row.codigo}`,
                otherContent: `En dicho caso, se entenderá practicada la notificación a fecha de hoy.`,
                boton: "Aceptar",
                funcion: resolverSolicitud,
                valorFuncion: row.fechaResolucion,
                destinoCerrar:null,
              });
            } 
            if (row.estadoMostrar === "RESOLUCION" && row.fechaResolucion !== null) {
              handleShow({
                mensaje: true,
                titulo: `Resolución notificada el: ${formateoFecha(
                  row.fechaResolucion
                )}`,
                // otherContent: `${infoRec.info}`,
                tipo: "tituloBorrador",
                destinoCerrar: null,
              });
            }
          }
        }}
      ></i>
    ),
  };

  useEffect(() => {}, []);

  return (
    <>
      <div className="container-fluid" style={{ marginTop: "0px" }} role="main" data-landmark-index="4">
        <div>
          <div style={marginTop}>
            {loading ? (
              <DataTable
                className="table-responsive"
                columns={[...ConstantesTabla.columnasSolicitudes, accionSol]}
                data={solicitudes}
                pagination
                paginationComponentOptions={ConstantesTabla.paginacionOpt}
                noDataComponent={<span>No se encontró ninguna solicitud</span>}
                customStyles={ConstantesTabla.customStyles}
                fixedHeader
                fixedHeaderScrollHeight="600px"
                style={marginTop}
              />
            ) : (
              <>
                <SpinnerCircle></SpinnerCircle>
              </>
            )}
          </div>
        </div>
      </div>
      {show.mensaje ? (
        <ModalMensajes
          show={show.mensaje}
          handleClose={handleClose}
          titulo={show.titulo}
          tipo={show?.tipo}
          content={show?.content}
          content2={show?.content2}
          contentBold={show?.contentBold}
          otherContent={show?.otherContent}
          boton={show?.boton}
          handleResolucion={handleResolucion}
          destinoCerrar={show?.destinoCerrar}
        ></ModalMensajes>
      ) : null}
    </>
  );
};

export default memo(Solicitudes);
